<template>
	<div>
		<Breadcrumbs main="port.resource" title="port.header"/>
		<!-- Container-fluid starts-->
		<div class="container-fluid">
            <div>
            <div v-show="process === 'add'" class="row ">
                <div id="addPort" class="col-sm-12 gradient-wy">
                    <div class="d-flex flex-row justify-content-between mx-1">
                        <div class="row ml-3" v-b-hover="handleHover">
                            <h2 class="text-primary mt-3">{{ $t('port.add') }}</h2>
                            <span class="text-danger" style="font-size: 30px; font-weight: bold; cursor: pointer" @click="process = 'info' ">&times;</span>
                            <span v-show="isHovered" class="text-danger">{{ $t('port.cancelReturn')  }} </span>
                        </div>
                    </div>
                    <form class="theme-form">
                        <div class="row ml-2">
                            <div class="col-sm-2" role="group">
                                <label for="id" class="col-form-label pt-0 f-w-600"  style="font-size:16px;">{{$t("port.portId") }}</label>
                                <b-form-input
                                    id="id"
                                    style="font-size:16px;" 
                                    v-model="id"
                                    type="text"
                                    :state="idState"
                                    :formatter="formatter"
                                    aria-describedby="input-live-help-id input-live-feedback-id"
                                    :placeholder="$t('port.portIdPh')"
                                >
                                </b-form-input>
                                <b-form-invalid-feedback id="input-live-feedback-id"> {{ $t("port.portId5CapitalChrAllow") }}</b-form-invalid-feedback>
                                <b-form-text id="input-live-help-id">{{ $t("port.portIdHelp") }}</b-form-text>           
                            </div>                       

                            <div class="col-sm-4" role="group">
                                <label for="portName" class="col-form-label pt-0 f-w-600" style="font-size:16px;">{{$t("port.pName") }}</label>
                                <b-form-input
                                    id="pName"
                                    style="font-size:16px;" 
                                    v-model="pName"
                                    type="text"
                                    :formatter="formatter"
                                    aria-describedby="input-live-help-pName input-live-feedback-pName"
                                    :placeholder="$t('port.portNamePh')"
                                >
                                </b-form-input>
                                <b-form-invalid-feedback id="input-live-feedback-pName"> {{ $t("port.portNameCapitalChrAllow") }}</b-form-invalid-feedback>
                                <b-form-text id="input-live-help-pName">{{ $t("port.pNameHelp") }}</b-form-text>           
                            </div>  
                            <div class="col-sm-3">
                                <label for="cntryCode" class="col-form-label pt-0 f-w-600" style="font-size:16px;"> {{ $t("port.cntry") }}</label>                                                                       
                                <v-select 
                                    class="style-chooser" 
                                    style="font-size:16px;" 
                                    v-model="cntryCode" 
                                    :options="cntryList" 
                                    :reduce="text => text.value"
                                    label = "text"
                                    :placeholder="$t('surcharge.plsSelect')"
                                >                            
                                </v-select>
                            </div> 
                            <div class="col-sm-1 mt-4">
                                <b-button  style="font-size:20px"  type="button" @click="handleSave">{{ $t('container.save') }}</b-button>
                            </div>
                            <div class="col-sm-1 mt-4">
                                <button class="btn btn-danger btn-block" style="font-size:20px"  type="button" @click="clickCancelProcess">{{ $t('matchTx.cancel') }}</button>
                            </div> 
                        </div>
                    </form>
                </div>
            </div>
            <div v-show="process === 'update' " class="row">
                <div class="col-sm-12 gradient-ow">
                    <div class="row ml-3" v-b-hover="handleHover">
                        <h3 class="text-primary mt-3">{{ $t('port.edit') }}</h3>
                        <span class="text-danger" style="font-size: 30px; font-weight: bold; cursor: pointer" @click="clickCancelProcess">&times;</span>
                        <span v-show="isHovered" class="text-danger">{{ $t('port.cancelReturn')  }} </span>
                    </div>
                    <form class="theme-form">
                        <div class="row">
                            <div class="col-sm-2" role="group">
                                <label for="id" class="col-form-label pt-0 f-w-600"  style="font-size:16px;">{{$t("port.portId") }}</label>
                                <b-form-input
                                    id="id"
                                    style="font-size:16px;" 
                                    v-model="id"
                                    type="text"
                                    disabled
                                >
                                </b-form-input>      
                            </div>                       
                            <div class="col-sm-4" role="group">
                                <label for="portName" class="col-form-label pt-0 f-w-600" style="font-size:16px;">{{$t("port.pName") }}</label>
                                <b-form-input
                                    id="pName"
                                    style="font-size:16px;" 
                                    v-model="pName"
                                    type="text"
                                    :formatter="formatter"
                                    :placeholder="$t('port.portNamePh')"
                                >
                                </b-form-input>
                                <b-form-invalid-feedback id="input-live-feedback"> {{ $t("port.portNameCapitalChrAllow") }}</b-form-invalid-feedback>
                                <b-form-text id="input-live-help">{{ $t("port.pNameHelp") }}</b-form-text>           
                            </div>  
                            <div class="col-sm-3">
                                <label for="cntryCode" class="col-form-label pt-0 f-w-600" style="font-size:16px;"> {{ $t("port.cntry") }}</label>                                                                       
                                <v-select 
                                    class="style-chooser" 
                                    style="font-size:16px;" 
                                    v-model="cntryCode" 
                                    :options="cntryList" 
                                    :reduce="text => text.value"
                                    label = "text"
                                    :placeholder="$t('surcharge.plsSelect')"
                                >                            
                                </v-select>
                            </div> 
                            <div class="col-sm-1 mt-4">
                                <button class="btn btn-warning btn-block" style="font-size:20px"  type="button" @click="handleUpdate">{{ $t('container.update') }}</button>
                            </div>
                            <div class="col-sm-1 mt-4">
                                <button class="btn btn-danger btn-block" style="font-size:20px"  type="button" @click="clickCancelProcess">{{ $t('matchTx.cancel') }}</button>
                            </div> 
                        </div>


                    </form>
                </div>
            </div>                
                <div class="divider"> </div>                    
                <div class="row">
                    <h2 class="mb-1 mt-4 ml-3 f-w-600">{{ $t('port.portList') }}</h2>
                    <b-button v-show="process === 'info'" pill href="#addPort" size="sm" @click="process = 'add' " class="bg-primary mb-4 mt-3 ml-3 ">
                        <span class="f-w-600 text-white" style="font-size: 18px;">{{ $t('port.add') }} </span>
                    </b-button>            
                    <b-col lg="3" class="ml-3 mt-3">
                        <b-form-group
                        :label="$t('matchTx.filter')"
                        label-for="filter-input"
                        label-cols-sm="3"
                        label-align-sm="right"
                        label-size="lg"
                        class="mb-0"
                        >
                        <b-input-group size="sm">
                            <b-form-input
                            id="filter-input"
                            v-model="filter"
                            type="search"
                            :placeholder="$t('matchTx.typeToSearch')"
                            class="text-info"
                            style="font-size: 18px;"
                            ></b-form-input>
                            <b-input-group-append>
                            <b-button size="md" variant="primary" :disabled="!filter" @click="filter = ''">
                                {{ $t('matchTx.clear') }}
                            </b-button>
                            </b-input-group-append>
                        </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col lg="5" class="my-1">
                        <b-form-group
                        v-model="sortDirection"
                        :label="$t('matchTx.filterOn')"
                        :description= "$t('matchTx.uncheck')"
                        label-cols-sm="3"
                        label-align-sm="right"
                        label-size="lg"
                        class="mb-0"
                        v-slot="{ ariaDescribedby }"
                        >
                        <b-form-checkbox-group
                            v-model="filterOn"
                            :aria-describedby="ariaDescribedby"
                            class="mt-1 text-info"
                            plain
                        >
                            <b-form-checkbox value="id">{{ $t('port.portId') }}</b-form-checkbox>                                                                
                            <b-form-checkbox value="pName">{{ $t('port.pName') }}</b-form-checkbox>
                            <b-form-checkbox value="cntryCode">{{ $t('port.cntryCode') }}</b-form-checkbox>                               
                            <b-form-checkbox value="cntry">{{ $t('port.cntry') }}</b-form-checkbox>   
                        </b-form-checkbox-group>
                        </b-form-group>
                    </b-col>   
                </div>
                <b-table
                    sticky-header
                    head-variant="light"
                    table-variant="success"
                    show-empty
                    sort-icon-left
                    stacked="md"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync= "sortDesc"
                    :sort-direction="sortDirection"
                    :filter="filter"
                    :filter-included-fields="filterOn"
                    :items="items"
                    :fields="fields"
                    :current-page="currentPage"
                    :per-page="perPage"
                    @filtered="onFiltered"
                >
                    <!-- A virtual column -->
                    <template #cell(index)="data">
                        {{ data.index + 1 }}
                    </template>
                    <template #cell(actions)="row" >
                        <b-button pill size="sm" @click="actUpdate(row.item)" class="m-1 btn-warning">
                           <span class="f-w-600" style="font-size: 16px;"> {{ $t('container.update') }}</span>
                        </b-button>
                        <b-button pill size="sm" @click="actDelete(row.item)" class="m-1 btn-danger">
                            <span class="f-w-600" style="font-size: 16px;"> {{ $t('container.delete') }}</span>
                        </b-button>                        
                    </template>
                    <template #empty>
                        <h5>{{ $t('reuse.noRecord') }}</h5>
                    </template>
                </b-table>
                <b-row>
                    <div class="row col-sm-8 ">
                    <b-col class="my-1 ml-3">
                        <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        align="fill"
                        class="my-0"
                        ></b-pagination>
                    </b-col>   
                    <b-col sm="3" md="6" class="my-1">
                        <b-form-group
                        :label= "$t('require.perPage')"
                        label-for="per-page-select"
                        label-cols-sm="6"
                        label-cols-md="4"
                        label-cols-lg="3"
                        label-align-sm="right"
                        label-size="sm"
                        class="mb-0"
                        >
                        <b-form-select
                            id="per-page-select"
                            v-model="perPage"
                            :options="pageOptions"
                        ></b-form-select>
                        </b-form-group>
                    </b-col>
                    </div>
                </b-row>
            </div>
        </div>
        <!-- Container-fluid Ends-->
    </div>
</template>
<script>
import { getCntryList, getDataAll, saveWithId, deleteItem, getCntryByCode} from "../../firebase"

export default {
	data(){
		return{
            process : "info",
            isHovered: false,
            id : '',
            pName : '',
            cntryCode : '',
            cntry : '',
            cntryList : [],
            items: [],
            fields: [
                { key: 'id', label: this.$t('port.portId'), sortable: true, variant: 'primary'},  
                { key: 'pName', label: this.$t('port.pName'), sortable: true , variant: 'info'},  
                { key: 'cntryCode', label: this.$t('port.cntryCode'), sortable: true , variant: 'success'},                
                { key: 'cntry', label: this.$t('port.cntry'), sortable: true , variant: 'success'},                                 

                { key: 'actions', label: this.$t('matchTx.actions'), variant: 'warning'},
            ],
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],
            sortBy: 'cntry',
            sortDesc: false,
            sortDirection: 'asc',
            filter: null,
            filterOn: [],
		}
	},

    computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
      },
      idState() {
            return this.id.length == 5 ? true : false
        }
    },
	mounted(){
        getDataAll( "Port", (res)=>{
            this.items = res
            this.totalRows = res.length
        })
        getCntryList((res)=>{
            this.cntryList = res
        })

	},
	methods:{
 
        onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },        
        handleHover(hovered) {
            this.isHovered = hovered
        },
        formatter(value) {
            return value.toUpperCase()
        },
        clickCancelProcess(){
            this.process = 'info'
            this.refresh()
        },
        async savePort(){
            await getCntryByCode (this.cntryCode ,async (res)=>{
                let payload = {
                    id : this.id,
                    pName : this.pName,
                    cntryCode: this.cntryCode,
                    cntry: res.cntry,
                }
                await saveWithId('Port', this.id, payload).then(async()=>{
                    await this.refresh()
                    this.$toasted.show(this.$t('reuse.successSave'), {theme: 'bubble', position: 'bottom-center', type: 'success' , duration: 5000});                                                    
                })
            })        
        },
        async handleSave(){
            let msg = 'completed'
            if (this.id ==='') {
                msg = 'port.addPortId'
            } else if (this.pName ===''){
                msg = 'port.addPortName'
            } else if (this.cntryCode ===''){
                msg = 'port.selCntry'
            } else if (this.cntryCode !== this.id.slice(0,2)){
                msg = 'port.portIdMismatchCntry'
            } 
            if (msg === 'completed'){
                 await this.savePort()                 
            } else {
                this.$toasted.show(this.$t(msg), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});     
            }
        },
        actDelete(item) {
            this.$bvModal.msgBoxConfirm(this.$t('container.confirmDeleteMsg'), {
            title: this.$t('matchTx.plsConfirm'),
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'warning',
            okTitle: this.$t('matchTx.yes'),
            cancelTitle: this.$t('matchTx.no'),
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
            })
            .then(async(value) => {
                if (value) {
                    await deleteItem( "Port", item.id)
                    await this.refresh()                   
                    this.$toasted.show( this.$t('container.deleted'), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});  
                } else {
                    return
                }
            })
            .catch(error => {
                this.$toasted.show( `Action-Delete: ${error}`, {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});  
            })
        },    
        async refresh(){
            await getDataAll( "Port", (res)=>{
                this.items = res
                this.totalRows = res.length
            })
            this.id = ''
            this.pName = ''
            this.cntryCode = ''
            this.cntry = ''
            this.process = 'info'
        },

        async handleUpdate(){
            let msg = 'completed'
            if (this.pName ===''){
                msg = 'port.addPortName'
            } else if (this.cntryCode ===''){
                msg = 'port.selCntry'
            } else if (this.cntryCode !== this.id.slice(0,2)){
                msg = 'port.portIdMismatchCntry'
            } 
            if (msg === 'completed'){
                await this.savePort()

            }else{
                this.$toasted.show(this.$t(msg), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});     
            }
        },

        async actUpdate(item) {
            this.process = "update"   // to pop up Update subMenu
            await getCntryByCode( item.cntryCode , (cntry)=>{
                this.cntry = cntry
                this.id = item.id
                this.pName = item.pName.trim() 
                this.cntryCode = item.cntryCode
            })
        }, 


    }
}
</script>
<style scoped>
 .gradient-wy {
   background: linear-gradient(135deg, white, yellow);
 }
 .gradient-ow {
   background: linear-gradient(135deg, orange, white);
 }

.divider {
    height: 5px;
    background-color: #f10909;
    margin:5px
}
</style>
